import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { Services } from "@/components/site/Services";
import { Pricing } from "@/components/site/Pricing";
import { About } from "@/components/site/About";
import { Gallery } from "@/components/site/Gallery";
import { ServiceAreas } from "@/components/site/ServiceAreas";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { MobileCallBar } from "@/components/site/MobileCallBar";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Header />
      <Hero />
      <TrustBar />
      <Services />
      <Pricing />
      <About />
      <Gallery />
      <ServiceAreas />
      <Testimonials />
      <Contact />
      <Footer />
      <MobileCallBar />
    </main>
  );
}
